import { CommonModule } from '@angular/common';
import { NgModule, ModuleWithProviders } from '@angular/core';

import { PmdInput } from './input.component';
import {
  PmdFormGroup,
  PmdFloatingLabel,
  PmdInputGroup,
  PmdInputGroupOutline,
  PmdInputGroupFilled,
  PmdTextfield,
  PmdInputGroupPrepend,
  PmdInputGroupAppend,
  PmdInputGroupIcon,
  PmdInputGroupText,
} from './form-group.component';

@NgModule({
  imports: [CommonModule],
  declarations: [
    PmdInput,
    PmdFormGroup,
    PmdFloatingLabel,
    PmdInputGroup,
    PmdInputGroupOutline,
    PmdInputGroupFilled,
    PmdTextfield,
    PmdInputGroupPrepend,
    PmdInputGroupAppend,
    PmdInputGroupIcon,
    PmdInputGroupText,
  ],
  exports: [
    PmdInput,
    PmdFormGroup,
    PmdInputGroupOutline,
    PmdInputGroupFilled,
    PmdFloatingLabel,
    PmdInputGroup,
    PmdTextfield,
    PmdInputGroupPrepend,
    PmdInputGroupAppend,
    PmdInputGroupIcon,
    PmdInputGroupText,
  ],
})
export class PmdFormGroupModule {
  static forRoot(): ModuleWithProviders<PmdFormGroupModule> {
    return { ngModule: PmdFormGroupModule };
  }
}
